import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate, NavLink } from 'react-router-dom';
import { authAPI } from '../../services/api';
import '../../styles/AdminStyles.css';

function AdminLayout() {
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(() => {
    return JSON.parse(localStorage.getItem('admin') || '{}');
  });

  useEffect(() => {
    // Check if admin is logged in
    const storedAdmin = JSON.parse(localStorage.getItem('admin') || '{}');
    if (!storedAdmin.id) {
      navigate('/admin');
    } else {
      setAdmin(storedAdmin);
    }
  }, [navigate]);

  const handleLogout = () => {
    authAPI.logout();
    navigate('/admin');
  };

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <h2>🏋️ Pilates House</h2>
          <p className="admin-subtitle">פאנל ניהול</p>
        </div>

        <nav className="admin-nav">
          <NavLink
            to="/admin/dashboard"
            className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}
          >
            📊 לוח בקרה
          </NavLink>

          <NavLink
            to="/admin/users"
            className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}
          >
            👥 ניהול משתמשים
          </NavLink>

          <NavLink
            to="/admin/sessions"
            className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}
          >
            📅 ניהול אימונים
          </NavLink>

          <NavLink
            to="/admin/training-types"
            className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}
          >
            🏷️ סוגי אימון
          </NavLink>

          <NavLink
            to="/admin/appointments"
            className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}
          >
            📝 תורים
          </NavLink>

          <NavLink
            to="/admin/notifications"
            className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}
          >
            🔔 הודעות
          </NavLink>

          <NavLink
            to="/admin/settings"
            className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}
          >
            ⚙️ הגדרות
          </NavLink>
        </nav>

        <div className="admin-sidebar-footer">
          <div className="admin-user-info">
            <p className="admin-user-name">{admin.full_name || admin.username}</p>
            <p className="admin-user-role">{admin.role === 'super_admin' ? 'מנהל ראשי' : 'מנהל'}</p>
          </div>
          <button onClick={handleLogout} className="admin-logout-button">
            🚪 התנתק
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
